import React from "react";
import { Controller } from "react-hook-form";
import { getValueFromObject } from "../../utils/basic";
import RadioGroup from "./RadioGroup";

const ControlledRadioGroup = ({
  formProps,
  name,
  validationKey,
  ignoreError = false,
  ...otherProps
}) => {
  const {
    control,
    formState: { errors },
    rules,
  } = formProps;

  const isError =
    getValueFromObject(errors, name) !== undefined && !ignoreError;

  return (
    <Controller
      name={name}
      control={control}
      rules={getValueFromObject(rules, validationKey ?? name)}
      render={({ field: { onChange, onBlur, value } }) => (
        <RadioGroup
          {...otherProps}
          value={value}
          error={isError}
          helperText={
            !isError
              ? otherProps.helperText
              : !ignoreError
              ? getValueFromObject(errors, name)?.message
              : undefined
          }
          onChange={(v) => {
            onChange(v);
            if (!!otherProps.onChange) {
              otherProps.onChange(v);
            }
          }}
          onBlur={() => {
            onBlur();
            if (!!otherProps.onBlur) {
              otherProps.onBlur(value);
            }
          }}
        />
      )}
    />
  );
};

export default ControlledRadioGroup;
